import "./App.css";

import Header from "./components/Header";
import AutoComplete from "./components/AutoComplete";

function App() {
  return (
    <>
      <Header />
      <AutoComplete />
    </>
  );
}

export default App;
